<style lang="stylus">
    .BaseSet-maintitle
        right-view-title()
        font-weight 700
        position relative
        .BaseSet-maintitle-icon
            position absolute
            transform translate(-50%,-50%)
            top 50%
            right 5px
    .BaseSet-container
        width 100%
        height 100%;
        overflow-y overlay
        overflow-x hidden
        // scrollbar-width thin
        padding $right-view-content-padding
        background-color $right-view-backcolor
        font-size $main-fontsize
        &.nopadding
            padding unset
</style>

<template>
    <div>
        <div class="BaseSet-maintitle" v-if="false">
            <p>{{ setTitle }}</p>
            <div class="BaseSet-maintitle-icon">
                <slot name="icon"></slot>
            </div>
        </div>
        <div class="BaseSet-container" :class="{ nopadding: noPadding }">
            <slot></slot>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({})
    export default class BaseSet extends Vue {
        @Prop()
        setTitle: string;
        @Prop()
        noPadding: boolean;

        mounted() {}
        created() {}
    }
</script>
